import { Group, Paper, Stack, Text, ThemeIcon } from '@mantine/core';
import type { LucideIcon } from 'lucide-react';

export type PatientStatTileProps = {
  label: string;
  value: string;
  icon: LucideIcon;
  color: string;
};

export function PatientStatTile({
  label,
  value,
  icon: Icon,
  color,
}: PatientStatTileProps) {
  return (
    <Paper withBorder p='md' radius='md' h='100%'>
      <Stack gap='sm' justify='space-between' h='100%'>
        <Group justify='space-between' align='flex-start' wrap='nowrap'>
          <Text size='xs' c='dimmed' tt='uppercase' fw={700} lh={1.3}>
            {label}
          </Text>
          <ThemeIcon variant='light' color={color} size='md' radius='md'>
            <Icon size={16} />
          </ThemeIcon>
        </Group>
        <Text fw={700} size='xl' lh={1.2}>
          {value}
        </Text>
      </Stack>
    </Paper>
  );
}
